import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ModalComponent } from "../../modules/modal/modal.component";
import { ModalHeaderComponent } from "../../modules/modal/modal.header.component";
import { EventSummary } from "../../modules/s25-swarm-schedule/s25.event.summary.service";
import { EventProfile } from "../../services/event.service";
import { S25EventSummaryDataComponent } from "./s25.event.summary.data.component";

@Component({
    template: `
        <s25-modal-header [data]="params()"></s25-modal-header>
        <div class="modal-body">
            @if (params()?.summary) {
                <s25-ng-event-summary-data
                    [eventId]="params()!.eventId"
                    [summary]="params()!.summary"
                    [dateFormat]="params()!.dateFormat"
                    [timeFormat]="params()!.timeFormat"
                    [profileReservations]="params()!.profileReservations"
                    [isModal]="true"
                ></s25-ng-event-summary-data>
            }
            <div class="ngCenter">
                <button (click)="params()?.closeModal?.()" class="aw-button aw-button--outline">OK</button>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalHeaderComponent, S25EventSummaryDataComponent],
})
export class ModalEventSummaryComponent extends ModalComponent<EventSummaryModalData> {}

export interface EventSummaryModalData {
    summary: EventSummary;
    eventId: number;
    dateFormat?: string;
    timeFormat?: string;
    profileReservations?: Array<EventProfile> | false;
}
